import type { FC } from "react";
import { ExperienceGroup } from "src/constants/experienceGroups";
import UserCubit, {
  ProfileAttributesKeys
} from "src/state/UserCubit/UserCubit";
import { useBloc } from "src/state/state";
import {
  DebugBadge,
  DebugButton,
  DebugFormGroup,
  DebugKeyValue
} from "./debug.styles";

const DebugExperienceGroup: FC = () => {
  const [{ profileAttributes }, cubit] = useBloc(UserCubit);
  const currentGroup =
    profileAttributes?.[ProfileAttributesKeys.experienceGroup];

  const isHwjOrEdj =
    currentGroup?.startsWith("HWJ_") ?? currentGroup?.startsWith("EDJ_");

  const handleChange = (value: string) => {
    cubit.emit({
      ...cubit.state,
      profileAttributes: {
        ...(cubit.state.profileAttributes ?? {}),
        [ProfileAttributesKeys.experienceGroup]: value || undefined
      } as typeof cubit.state.profileAttributes
    });
  };

  const handleRefresh = async () => {
    await cubit.getProfileAttributes();
  };

  return (
    <div>
      <DebugKeyValue>
        <span className="key">Current Group</span>
        <span className="value">
          {currentGroup ? (
            <DebugBadge variant={isHwjOrEdj ? "success" : "warning"}>
              {currentGroup}
            </DebugBadge>
          ) : (
            <DebugBadge variant="info">Not set</DebugBadge>
          )}
        </span>
      </DebugKeyValue>

      <DebugKeyValue>
        <span className="key">Coaching Card</span>
        <span className="value">
          {isHwjOrEdj ? (
            <DebugBadge variant="success">Visible</DebugBadge>
          ) : (
            <DebugBadge variant="warning">Hidden</DebugBadge>
          )}
        </span>
      </DebugKeyValue>

      <DebugFormGroup style={{ marginTop: "0.75rem" }}>
        <label>Override Experience Group (local only)</label>
        <select
          value={currentGroup ?? ""}
          onChange={(e) => handleChange(e.target.value)}
        >
          <option value="">— None —</option>
          {Object.values(ExperienceGroup).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
      </DebugFormGroup>

      <DebugButton
        className="small"
        style={{ marginTop: "0.5rem" }}
        onClick={() => void handleRefresh()}
      >
        Refresh from Server
      </DebugButton>
    </div>
  );
};

export default DebugExperienceGroup;
